export { default as Footer } from './CardFooter';
export { default as Item } from './CardFooterItem';


// WEBPACK FOOTER //
// ./src/components/Card/Footer/index.ts